module.exports = __webpack_public_path__ + "static/media/ratnesh.d17815bb.png";